// extracted by mini-css-extract-plugin
export default {"tag":"InfoTag_tag__eaviC","tag__text":"InfoTag_tag__text__phdtu"};